<template>
	<div>
		<!-- logo 时间 -->
		<q-head></q-head>
		<!-- banner -->
		<qBanner></qBanner>
		
		
	
		
		<div class="read">
			<div class="read-hd">
				<q-title title="门诊缴费" time="86"></q-title>
				<q-step :step="3"></q-step>
			</div>
			
			
			<div  class="read-bd-title fc"><i ></i><h3 >预约信息</h3></div>
			
			
			<!-- 01：金额为0 -->
			<div class="k-box b1" >
				<div class="book-info fc-bet" style="height: 240px;">
					<div class="flex1">
						<div class="fc ">
							<div class="left">
								<img src="../../assets/people.png" >
							</div>
							<div class="right flex1">
								<div class="fc-bet">
									<div>
										<span><em class="em2"></em>费用合计：</span><b>0.00元</b>
									</div>
									<div>
										<span>自费合计：</span><b>0.00元</b>
									</div>
								</div>
								<div class="fc-bet">
									<div>
										<span>医保账户支付：</span><b>0.00元</b>
									</div>
									<div>
										<span>医院账户支付：</span><b>0.00元</b>
									</div>
								</div>
								<div class="fc-bet">
									<div>
										<span>医保统筹支付：</span><b>0.00元</b>
									</div>
									<div>
										<span>现金支付：</span><b style="color:#FF1111;">0.00元</b>
									</div>
								</div>
							</div>
						</div>
						
						
						<!-- 还需要支付 -->
						
						<div class="still-need-pay">
							您还需支付<b>35151.10</b>元
						</div>
					</div>
					
				</div>
			</div>
			<!-- 02：金额为0的情况 预约挂号 -->
			<div class="k-box b1 k-box2" style="display: none;">
				<div class="book-info fc-bet" style="height: 240px;">
					<div class="flex1">
						<div class="fc ">
							<div class="left">
								<img src="../../assets/people.png" >
							</div>
							<div class="right flex1">
								<div class="fc-bet">
									<div>
										<span>预约日期：</span><b>2021-11-17</b>
									</div>
									<div>
										<span>就诊医生：</span><b>张三</b>
									</div>
								</div>
								<div class="fc-bet">
									<div>
										<span>就诊时段：</span><b>08:00-08:30</b>
									</div>
									<div>
										<span>医生级别：</span><b>副主任</b>
									</div>
								</div>
								<div class="fc-bet">
									<div>
										<span>就诊科室：</span><b>呼吸内科</b>
									</div>
									<div>
										<span>挂号金额：</span><b style="color:#FF1111;">0.00元</b>
									</div>
								</div>
							</div>
						</div>
						
						
					</div>
					
				</div>
			</div>
			<!-- 02：金额为0的情况 预约挂号over -->
			<!-- 03：金额为0的情况 挂号信息 -->
			<div  class="read-bd-title fc" v-if="false"><i ></i><h3 >挂号信息</h3></div>
			<div class="k-box b1 k-box2" v-if="false">
				<div class="book-info fc-bet" style="height: 240px;">
					<div class="flex1">
						<div class="fc ">
							<div class="left">
								<img src="../../assets/people.png" >
							</div>
							<div class="right flex1">
								<div class="fc-bet">
									<div>
										<span>预约日期：</span><b>2021-11-17</b>
									</div>
									<div>
										<span>就诊医生：</span><b>张三</b>
									</div>
								</div>
								<div class="fc-bet">
									<div>
										<span>就诊时段：</span><b>08:00-08:30</b>
									</div>
									<div>
										<span>医生级别：</span><b>副主任</b>
									</div>
								</div>
								<div class="fc-bet">
									<div>
										<span>就诊科室：</span><b>呼吸内科</b>
									</div>
									<div>
										<span>挂号金额：</span><b style="color:#FF1111;">0.00元</b>
									</div>
								</div>
							</div>
						</div>
						
						
					</div>
					
				</div>
			</div>
			<!-- 03：金额为0的情况 挂号信息 over -->
			
			
			
			
			
			
			
			<div  class="read-bd-title fc"><i ></i><h3 >请直接点击【确认结算】</h3></div>
			
			<div class="k-box">
				<div class="fc-bet pay-select">
					<a class="pay-item fcc">
						<div class="icon"><img src="../../assets/pay-alipay.png" ></div>
						<p>
							支付宝支付
						</p>
					</a>
					<a class="pay-item fcc">
						<div class="icon">
							<img src="../../assets/pay-weixin.png" >
						</div>
						<p>
							支付宝支付
						</p>
					</a>
				</div>
			</div>
			
			
			
			<div class="foot-buttons fc-bet">
				<a href="/" class="btn-home fcc">
					<img src="../../assets/icon/icon-home.png" >
					<span>首页</span>
				</a>
				<a href="/" class="btn-pay fcc">
					<img src="../../assets/icon/icon-ok.png" >
					<span>确认结算</span>
				</a>
				<a class="btn-return fcc" @click="returnStep()">
					<img src="../../assets/icon/icon-return.png" >
					<span>返回</span>
				</a>
			</div>
		
		</div>
		
	</div>
</template>

<script>
	import qHead from '@/components/q-head/q-head.vue';
	import qBanner from '@/components/q-head/q-banner.vue';
	import qTitle from '@/components/q-read/q-title.vue';
	import qStep from '@/components/q-read/q-step.vue';
	export default {
		components: {
			qHead,qBanner,qStep,qTitle
		},
		data() {
			return {
				
			}
		},
		mounted() {
			
		},
		methods:{
			
			
		},
		beforeDestroy() {
			//clearInterval(this.timer);
		}
		
	}
</script>

<style scoped lang="less">
	
</style>
